import Icon from './Icon'
import {TCompanyBenefit} from '../CompanyDetail/type';
import {colors} from '@microfrontends/react-components';
import {BenefitDescription, BenefitName, CardCss, Line} from './Benefit.css'
interface IProps {
	benefit: TCompanyBenefit
	cardStyle?: {
		bgColor: string
		iconColor: string
	}
}
export default function BenefitCard({
	benefit,
	cardStyle: { bgColor, iconColor } = {bgColor: colors.primary[95], iconColor: colors.primary[40]}
}: IProps) {
	return (
		<CardCss color={bgColor}>
			<Icon benefitId={benefit.benefitId} color={iconColor} />
			<div style={{position:'relative'}}>
				<BenefitName>
					{benefit.benefitName}
				</BenefitName>
				<Line/>
			</div>
			<BenefitDescription
				dangerouslySetInnerHTML={{
					__html: benefit.benefitDescription
				}}
			/>
		</CardCss>
	)
}
